const getters = {
  cat: state => state.cat,
  cats: state => state.cats,
  trashedData: state => state.trashedData,
  sectionName: state => state.sectionName,

}
export default getters
